/**
 * Nav Presenter
 */
class NavPresenter {

	constructor() {

		this.countryCodes = new CountryCodes();
		this.view = new NavView(this);

		/*
		 * Listeners
		 */

		$(document).on(Model.CART_RETRIEVED, $.proxy(function(_event, cart) {
			// set the number of cart items in the navbar
			this.view.setCartItems(cart.items);
		}, this));

		$(document).on(Model.CART_QUANTITY_UPDATED, $.proxy(function(_event, cart) {
			// updating cart quantities triggers sending back the entire cart, so we cab update the number of cart items in the navbar
			this.view.setCartItems(cart.items);
		}, this));

		$(document).on(Model.POST_MESSAGE, $.proxy(function(_event, message) {
			// show the posted message
			this.view.showMessage(message);
		}, this));

		/*
		 * Initialisation
		 */

	}

	/*
	 * Actions
	 */

	/*
	 * Getters and Setters
	 */

	getThreeLetterCode(twoLetterCode) {
		const map = this.countryCodes.getMap();
		if (twoLetterCode != null && map.has(twoLetterCode) == true) {
			// return the three letter code
			return map.get(twoLetterCode);
		}
		else {
			// return the two letter code as a fallback
			return twoLetterCode;
		}
	}

}